import React, { Component } from 'react'
import { connect } from 'react-redux'
import { recoverStart, recoverStartReset } from '../actions/auth'
import PublicRecoverStartComponent from '../components/PublicRecoverStart'
import { withRouter, Redirect } from 'react-router-dom'

class PublicRecoverStart extends Component {

    constructor(props) {
        super(props)
        this.onSubmit = this.onSubmit.bind(this)
    }

    onSubmit(refs) {
        const formData = {
            email: refs.email.refs.input.value
        }
        this.props.recoverStart(formData)
    }

    componentDidMount() {
        if (this.props.complete) {
            this.props.recoverReset()
        }
    }

    render() {
        if (this.props.username) {
            return <Redirect to="/" />
        }
        return (
            <PublicRecoverStartComponent
                {...this.props}
                onSubmit={this.onSubmit}
            />
        )
    }
}

const mapStateToProps = (state) => {
    const nextProps = Object.assign({}, state.auth)
    return nextProps
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        recoverStart: (formData) => {
            dispatch(recoverStart(formData))
        },
        recoverReset: () => {
            dispatch(recoverStartReset())
        }
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PublicRecoverStart))



// WEBPACK FOOTER //
// ./src/containers/PublicRecoverStart.js